import { useDispatch } from "react-redux";
import { useTeamConfig } from "./useTeamConfig";
import { useTheme } from "@mui/material";
import { useRouterExtended as nextRouterExtended } from "./useRouterExtended";

export const useRouterExtended = nextRouterExtended;

export function useAppSystem() {
  const router = useRouterExtended();
  const dispatch = useDispatch();
  const teamConfig = useTeamConfig();
  const theme = useTheme();

  return {
    router,
    dispatch,
    teamConfig,
    theme,
  };
}

export type AppSystemProps = ReturnType<typeof useAppSystem>;
